import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

export const HeaderWrapper = styled.div`
    padding: 30px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-radius: 15px;
    background-color: ${({ theme }) => theme.colors.primaryWhite};
    box-shadow: 6px 12px 30px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;

    &:before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 8px;
        background-color: ${({ theme }) => theme.colors.primary40};
    }

    .dds-text-field:first-child {
        .MuiInputBase-root {
            ${getFontStyle('h2Bold')}

            line-height: 1;
        }
    }
`
